import { ButtonGroup, PrimaryButton, Stack, Text } from "@certn/cascadia";
import { Container, ExpandableCard, Illustration } from "@certn/cascadia-react";
import { ProgressStepper } from "@certn/cascadia-react/components/stepper/ProgressStepper";
import { t } from "i18next";
import React, { useContext } from "react";
import { Trans } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { DCOReviewContext } from "../DCOReviewContext";
import { DCOReviewPageLayout } from "../DCOReviewLayout";

export function AllSetStep() {
  const navigate = useNavigate();

  const { dispute } = useContext(DCOReviewContext);

  return (
    <DCOReviewPageLayout
      onComplete={() => {
        navigate("/");
      }}
      nextDisabled={false}
    >
      <Illustration name="success" size={88} />
      <Container>
        {dispute ? (
          <>
            <Text style="global/body-primary" color="text-base">
              <Trans>Your dispute has been submitted</Trans>
            </Text>
            <ButtonGroup justify="start">
              <PrimaryButton
                onPress={() => {
                  navigate("/");
                }}
                testID="next-step-complete-dco-review-button"
              >
                {t("Return to dashboard")}
              </PrimaryButton>
            </ButtonGroup>
            <ExpandableCard
              onToggle={function noRefCheck() {}}
              subtitle={
                <Stack gap="space-0">
                  <ProgressStepper
                    steps={[
                      {
                        status: "ACTIVE",
                        title: t("Review your dispute"),
                        description: t(
                          "We will review your submission and contact you if we need any further information"
                        ),
                      },
                      {
                        status: "ACTIVE",
                        title: t("Escalation to NPCS"),
                        description: t(
                          "Once our review is complete, your dispute will be raised with the National Police Checking Service (NPCS) for further assessment. This process can take 3 to 15+ days."
                        ),
                      },
                      {
                        status: "ACTIVE",
                        title: t("NPCS review outcome"),
                        description: (
                          <>
                            <Trans>
                              The NPCS will assess your dispute and determine
                              one of the following outcomes:
                            </Trans>
                            <ul>
                              <li>
                                <Trans>
                                  If the original result was correctly released,
                                  we will notify you and release the result to
                                  your employer or designated third party.
                                </Trans>
                              </li>
                              <li>
                                <Trans>
                                  If the original result was incorrectly
                                  released, your application will be reopened,
                                  and we will notify you when the corrected
                                  result is available.
                                </Trans>
                              </li>
                            </ul>
                          </>
                        ),
                      },
                      {
                        status: "ACTIVE",
                        title: t("Reopened results"),
                        description: (
                          <>
                            <Trans>
                              If your result is reopened and your updated result
                              contains a disclosable court outcome, you will be
                              notified before the result is shared with your
                              employer or third party.
                            </Trans>
                          </>
                        ),
                      },
                    ]}
                  />
                </Stack>
              }
              title="What happens next"
            />
          </>
        ) : (
          <>
            <Text style="global/body-secondary" color="text-base">
              <Trans>
                <strong>No further action required</strong>—your report results
                are as expected. Your results will be made available to your
                employer or third party as per the instructions on your initial
                request.{" "}
              </Trans>
            </Text>
            <ButtonGroup justify="start">
              <PrimaryButton
                onPress={() => {
                  navigate("/");
                }}
                testID="next-step-complete-dco-review-button"
              >
                {t("Return to dashboard")}
              </PrimaryButton>
            </ButtonGroup>
          </>
        )}
      </Container>
    </DCOReviewPageLayout>
  );
}
